module.exports = __webpack_public_path__ + "static/banner-ec91e09ce5a9915835a0415797d5cc3d.jpg";